import React from 'react';
import PropTypes from 'prop-types';
import AssumptionsTable from '../Components/AssumptionsTable';
import defaultGeneralAssumptionsMap from './assumptionsConst';


const realStateIncome = (assumption) => {
  if (!assumption) {
    return {
      RealEstateIncome: null,
    };
  }

  const realStateIncomeWithoutZeroAmount = assumption.reduce((realStateIncomeAcc, realState) => {
    if (realState.Amount === 0) {
      return realStateIncomeAcc;
    }
    return [
      ...realStateIncomeAcc,
      realState,
    ];
  }, []);

  if (realStateIncomeWithoutZeroAmount.length > 0) {
    return {
      RealEstateIncome: realStateIncomeWithoutZeroAmount,
    };
  }

  return {
    RealEstateIncome: null,
  };
};

const generalAssumptionsLabels = assumptions => (
  Object.keys(assumptions).reduce((newAssumptions, key) => {
    if (key === 'RealEstateIncome') {
      return {
        ...newAssumptions,
        ...realStateIncome(assumptions[key]),
      };
    }
    return {
      ...newAssumptions,
      [key]: assumptions[key],
    };
  }, {})
);


const generalAssumptionsView = ({
  generalAssumptions,
}) => {

  return (
    <AssumptionsTable
      title="General Assumptions"
      valuesList={generalAssumptionsLabels(generalAssumptions)}
      labelList={defaultGeneralAssumptionsMap}
    />
  );
};

generalAssumptionsView.propTypes = {
  generalAssumptions: PropTypes.shape({}).isRequired,
};

export default generalAssumptionsView;
